import React, { useState } from "react";
import { Offcanvas, Form, Alert, Spinner, Badge } from "react-bootstrap";
import { FaDownload, FaFileCsv, FaFileExcel, FaFilePdf } from "react-icons/fa";

const AuditExport = ({ Show, Hide, Title, auditCount, onConfirm }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [formData, setFormData] = useState({
    format: "csv",
    includeHeaders: true,
    includeTimestamp: true,
    dateRange: "all",
  });

  const formats = [
    { value: "csv", label: "CSV", icon: <FaFileCsv /> },
    { value: "excel", label: "Excel", icon: <FaFileExcel /> },
    { value: "pdf", label: "PDF", icon: <FaFilePdf /> },
  ];

  const dateRanges = [
    { value: "all", label: "All Records" },
    { value: "today", label: "Today" },
    { value: "week", label: "Last 7 Days" },
    { value: "month", label: "Last 30 Days" },
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = () => {
    setButtonLoader(true);
    setTimeout(() => {
      setButtonLoader(false);
      if (onConfirm) onConfirm(formData.format);
      Hide();
    }, 1500);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" size="md">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title || "Export Audit Trail"}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Alert variant="info" className="d-flex align-items-start gap-2 py-2">
          <span>ℹ</span>
          <div style={{ fontSize: "13px" }}>
            Export the audit trail records. The export will include all filtered records.
            <div className="mt-1">
              <Badge className="bg-primary">{auditCount || 0} records</Badge> will be exported.
            </div>
          </div>
        </Alert>

        <div className="mb-3">
          <div className="mb-2">
            <span style={{ fontSize: "13px", color: "#6c757d", fontWeight: "600" }}>
              Export Format <span className="text-danger">*</span>
            </span>
          </div>
          <div className="d-flex gap-2">
            {formats.map((fmt) => (
              <button
                key={fmt.value}
                className={`${formData.format === fmt.value ? "updateProfile activee" : "updateProfile"} d-flex align-items-center gap-2`}
                onClick={() => setFormData(prev => ({ ...prev, format: fmt.value }))}
              >
                {fmt.icon}
                {fmt.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mb-3">
          <div className="mb-2">
            <span style={{ fontSize: "13px", color: "#6c757d", fontWeight: "600" }}>
              Date Range
            </span>
          </div>
          <Form.Select
            name="dateRange"
            value={formData.dateRange}
            onChange={handleInputChange}
          >
            {dateRanges.map((range, i) => (
              <option key={i} value={range.value}>{range.label}</option>
            ))}
          </Form.Select>
        </div>

        <div className="mb-3">
          <div className="mb-2">
            <span style={{ fontSize: "13px", color: "#6c757d", fontWeight: "600" }}>
              Export Options
            </span>
          </div>
          <Form.Check
            type="checkbox"
            id="export-headers"
            name="includeHeaders"
            checked={formData.includeHeaders}
            onChange={handleInputChange}
            label="Include column headers"
            className="mb-2"
          />
          <Form.Check
            type="checkbox"
            id="export-timestamp"
            name="includeTimestamp"
            checked={formData.includeTimestamp}
            onChange={handleInputChange}
            label="Include timestamp in filename"
          />
        </div>

        {formData.format === "pdf" && (
          <div className="p-2 bg-light rounded small text-muted">
            <FaFilePdf className="me-1" />
            PDF export includes all records with proper formatting, pagination, and compliance headers.
          </div>
        )}

        {formData.format === "excel" && (
          <div className="p-2 bg-light rounded small text-muted">
            <FaFileExcel className="me-1" />
            Excel export includes all records with proper formatting and filterable columns.
          </div>
        )}

        {formData.format === "csv" && (
          <div className="p-2 bg-light rounded small text-muted">
            <FaFileCsv className="me-1" />
            CSV export is compatible with most data analysis tools and spreadsheets.
          </div>
        )}
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top d-flex justify-content-end gap-2">
        <button
          onClick={handleSubmit}
          className="updateProfile"
          disabled={buttonLoader}
        >
          {buttonLoader ? (
            <div className="d-flex align-items-center gap-2">
              <Spinner size="sm" animation="border" variant="light" />
              <span>Exporting...</span>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <FaDownload />
              Export {auditCount || 0} Records
            </div>
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default AuditExport